import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkCenterDto } from '@app/generated/model';
import { LocationAdministrationControllerService } from '@app/generated/api/locationAdministrationController.service';
import { BaseService, Resource } from '@app/core/services/base.service';
import { ResourceType } from '@dwo/enums';

@Injectable({
  providedIn: 'root',
})
export class WorkCenterService extends BaseService {
  constructor(
    private locationController: LocationAdministrationControllerService,
    http: HttpClient,
  ) {
    super(http);
  }

  @Resource(ResourceType.LoadWorkCenters)
  loadWorkCenters(siteId: string): Observable<WorkCenterDto[]> {
    return this.locationController.getWorkCentersForSite(siteId) as Observable<WorkCenterDto[]>;
  }

  @Resource(ResourceType.AddWorkCenter)
  addWorkCenter(siteId: string, workCenter: WorkCenterDto): Observable<void> {
    return this.locationController.createWorkCenter(siteId, workCenter);
  }

  @Resource(ResourceType.UpdateWorkCenter)
  updateWorkCenter(siteId: string, workCenterId: string, workCenter: WorkCenterDto): Observable<void> {
    return this.locationController.updateWorkCenter(siteId, workCenterId, workCenter);
  }
}
